export const operateMenuDeprecatedRouteMap = {
  "/customers/:customerId/cloudflow": "/customers/:customerId/operate/cloudflow",
  "/customers/:customerId/cloudflow/edit/:flowId": "/customers/:customerId/operate/cloudflow/edit/:flowId",
  "/customers/:customerId/cloudflow/history": "/customers/:customerId/operate/cloudflow/history",
  "/customers/:customerId/cloudflow/history/:executionId":
    "/customers/:customerId/operate/cloudflow/history/:executionId",
  "/customers/:customerId/cloudflow/blueprints": "/customers/:customerId/operate/cloudflow/blueprints",
  "/customers/:customerId/blueprint/:flowId": "/customers/:customerId/operate/cloudflow/blueprints/:flowId",

  "/customers/:customerId/analytics/metrics": "/customers/:customerId/operate/metrics",
  "/customers/:customerId/analytics/metrics/create": "/customers/:customerId/operate/metrics/create",
  "/customers/:customerId/analytics/metrics/:metricId": "/customers/:customerId/operate/metrics/:metricId",
  "/customers/:customerId/analytics/metrics/labels": "/customers/:customerId/operate/metrics/labels",

  "/customers/:customerId/threads": "/customers/:customerId/operate/threads",
  "/customers/:customerId/threads/:threadId?": "/customers/:customerId/operate/threads/:threadId?",

  "/customers/:customerId/analytics/allocations": "/customers/:customerId/operate/allocations",
  "/customers/:customerId/analytics/allocations/create": "/customers/:customerId/operate/allocations/create",
  "/customers/:customerId/analytics/allocations/:allocationId":
    "/customers/:customerId/operate/allocations/:allocationId",
  "/customers/:customerId/analytics/allocations/labels": "/customers/:customerId/operate/allocations/labels",

  // attributions -> allocations
  "/customers/:customerId/analytics/attributions": "/customers/:customerId/operate/allocations",
  "/customers/:customerId/analytics/attributions/create": "/customers/:customerId/operate/allocations/create",
  "/customers/:customerId/analytics/attributions/:allocationId":
    "/customers/:customerId/operate/allocations/:allocationId",
  "/customers/:customerId/analytics/attribution-groups": "/customers/:customerId/operate/allocations",
  "/customers/:customerId/analytics/attribution-groups/create": "/customers/:customerId/operate/allocations/create",
  "/customers/:customerId/analytics/attribution-groups/:allocationId":
    "/customers/:customerId/operate/allocations/:allocationId",
};
